var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.content.link
    ? _c(
        "nuxt-link",
        {
          class: [
            "product-tile",
            {
              "product-tile--has-sub-image": _vm.content.subImage,
              "product-tile--wide": _vm.content.wide
            }
          ],
          attrs: { to: "/" + _vm.content.link }
        },
        [
          _c("div", { staticClass: "product-tile__image-box" }, [
            _vm.content.image
              ? _c("img", {
                  staticClass: "product-tile__image",
                  attrs: { src: _vm.content.image, alt: "" }
                })
              : _vm._e(),
            _c("div", { staticClass: "product-tile__sub-image-box" }, [
              _vm.content.subImage
                ? _c("img", {
                    staticClass: "product-tile__sub-image",
                    attrs: { src: _vm.content.subImage, alt: "" }
                  })
                : _vm._e()
            ])
          ]),
          _c("div", { staticClass: "product-tile__name" }, [
            _vm._v(_vm._s(_vm.content.name))
          ]),
          _c("div", { staticClass: "product-tile__flavor" }, [
            _vm._v(_vm._s(_vm.content.flavor))
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-422ebfb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-422ebfb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/ProductTile.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-422ebfb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/ProductTile.vue
// module chunks = 0 1 2